import { render } from "./LedgerConfigurationView.vue?vue&type=template&id=6d7f292a"
import script from "./LedgerConfigurationView.vue?vue&type=script&lang=js"
export * from "./LedgerConfigurationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__